import { Camera, CheckCircle2, ShieldCheck, MapPin } from "lucide-react";
import heroLego from "@/assets/hero-lego.jpg";

export const LocalTrustBento = () => {
  return (
    <section
      data-section="local-trust-bento"
      className="py-16 lg:py-24 bg-[#FAF8F5] dark:bg-background border-b border-stone-200/60 dark:border-border"
    >
      <div className="container mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-12">
          <p className="text-xs uppercase font-bold tracking-widest text-primary mb-3">
            Confianza y Seguridad
          </p>
          <h2 className="text-3xl sm:text-4xl font-display font-bold text-stone-900 dark:text-foreground tracking-tight">
            Una comunidad pensada para compartir con total tranquilidad en tu ciudad.
          </h2>
          <p className="mt-3 text-base sm:text-lg text-stone-600 dark:text-muted-foreground">
            Diseñamos cada detalle para proteger los sets de nuestros usuarios y garantizar una experiencia segura.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="relative rounded-3xl overflow-hidden bg-stone-900 text-white p-8 flex flex-col justify-between min-h-[300px]">
            <img
              src={heroLego}
              alt="Comunidad de fans LEGO en tu ciudad"
              className="absolute inset-0 w-full h-full object-cover opacity-35"
            />
            <div className="relative z-10">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white/20 backdrop-blur-md text-xs font-semibold text-white mb-4">
                <MapPin className="h-3.5 w-3.5 text-primary" />
                Tu ciudad · Proximidad real
              </span>
              <h3 className="text-2xl font-bold font-display">Intercambio cercano</h3>
              <p className="text-stone-300 text-sm mt-2">
                Conoce a personas con tu misma afición, ahorra en envíos y comparte la pasión por construir.
              </p>
            </div>
          </div>

          <div className="rounded-3xl bg-white dark:bg-card border border-stone-200/80 dark:border-border p-8 flex flex-col justify-between shadow-xs">
            <div>
              <div className="h-12 w-12 rounded-2xl bg-emerald-100 dark:bg-emerald-950 flex items-center justify-center text-emerald-600 dark:text-emerald-400 mb-6">
                <ShieldCheck className="h-6 w-6" />
              </div>
              <h3 className="text-xl font-bold text-stone-900 dark:text-foreground mb-3">
                Identidad y Biometría
              </h3>
              <p className="text-sm text-stone-600 dark:text-muted-foreground leading-relaxed">
                Verificamos el documento de identidad oficial y el reconocimiento facial de cada miembro antes de que pueda solicitar o prestar sets.
              </p>
            </div>
            <div className="pt-6 border-t border-stone-100 dark:border-border text-xs text-stone-500 flex items-center gap-2">
              <CheckCircle2 className="h-4 w-4 text-emerald-600" />
              Verificación 100% de usuarios activos
            </div>
          </div>

          <div className="rounded-3xl bg-white dark:bg-card border border-stone-200/80 dark:border-border p-8 flex flex-col justify-between shadow-xs">
            <div>
              <div className="h-12 w-12 rounded-2xl bg-primary/10 flex items-center justify-center text-primary mb-6">
                <Camera className="h-6 w-6" />
              </div>
              <h3 className="text-xl font-bold text-stone-900 dark:text-foreground mb-3">
                Fianza Swikly y Fotos
              </h3>
              <p className="text-sm text-stone-600 dark:text-muted-foreground leading-relaxed">
                El propietario puede fijar una fianza protegida sin cargos anticipados, y el estado del set queda registrado con fotos al entregar y devolver.
              </p>
            </div>
            <div className="pt-6 border-t border-stone-100 dark:border-border text-xs text-stone-500 flex items-center gap-2">
              <CheckCircle2 className="h-4 w-4 text-emerald-600" />
              Liberación automática al recibir el set
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocalTrustBento;
